"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Panel = _interopRequireDefault(require("angieslist-react-components/lib/Panel"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));

var _circularJson = _interopRequireDefault(require("circular-json"));

var _WorkflowConsumer = _interopRequireDefault(require("./WorkflowConsumer"));

var _WorkflowStepIdButton = _interopRequireDefault(require("./WorkflowStepIdButton"));

var _WorkflowPreviousButton = _interopRequireDefault(require("./WorkflowPreviousButton"));

var _WorkflowNextButton = _interopRequireDefault(require("./WorkflowNextButton"));

var _h, _h2, _h3, _hr, _h4;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function delayMilliseconds(milliseconds) {
  return new Promise(function (fulfill) {
    setTimeout(fulfill, milliseconds);
  });
}
/* eslint react/prefer-stateless-function: 0 */

/* eslint no-useless-constructor: 0 */


var WorkflowDebugInfo = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(WorkflowDebugInfo, _React$Component);

  var _super = _createSuper(WorkflowDebugInfo);

  function WorkflowDebugInfo() {
    var _this;

    (0, _classCallCheck2.default)(this, WorkflowDebugInfo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      useJumpBackBehavior: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleValidateTransition", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(fromStepId, toStepId) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return delayMilliseconds(2000);

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(WorkflowDebugInfo, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/(0, _jsx2.default)(_react.default.Fragment, {}, void 0, /*#__PURE__*/(0, _jsx2.default)(_Panel.default, {
        header: "WorkflowDebugInfo"
      }, void 0, /*#__PURE__*/(0, _jsx2.default)(_WorkflowConsumer.default, {}, void 0, function (_ref2) {
        var workflowDidMount = _ref2.workflowDidMount,
            currentStepId = _ref2.currentStepId,
            goToStep = _ref2.goToStep,
            getStepIds = _ref2.getStepIds,
            getNextStepId = _ref2.getNextStepId,
            getPreviousStepId = _ref2.getPreviousStepId,
            getStatus = _ref2.getStatus,
            extendedStateByStepId = _ref2.extendedStateByStepId;

        if (workflowDidMount) {
          return /*#__PURE__*/(0, _jsx2.default)(_react.default.Fragment, {}, void 0, /*#__PURE__*/(0, _jsx2.default)(_Row.default, {}, void 0, /*#__PURE__*/(0, _jsx2.default)(_Col.default, {
            sm: 12,
            md: 6
          }, void 0, /*#__PURE__*/(0, _jsx2.default)(_Row.default, {}, void 0, /*#__PURE__*/(0, _jsx2.default)(_WorkflowPreviousButton.default, {
            id: "sampleWorkflowPreviousButton",
            bsSize: "small",
            bsStyle: "info",
            flat: true,
            onValidateTransition: _this2.handleValidateTransition,
            autoShowLoading: true
          }, void 0, "PREVIOUS"), /*#__PURE__*/(0, _jsx2.default)(_WorkflowNextButton.default, {
            id: "sampleWorkflowNextButton",
            bsSize: "small",
            bsStyle: "warning",
            flat: true,
            onValidateTransition: _this2.handleValidateTransition,
            autoShowLoading: true
          }, void 0, "NEXT"), /*#__PURE__*/(0, _jsx2.default)(_Button.default, {
            id: "toggle-usejumpbackbehavior-btn",
            bsSize: "xsmall",
            bsStyle: "danger",
            onClick: function onClick() {
              return _this2.setState({
                useJumpBackBehavior: !_this2.state.useJumpBackBehavior
              });
            }
          }, void 0, "Toggle JumpBackBehavior (currently ".concat(_this2.state.useJumpBackBehavior ? 'on' : 'off', ")"))), /*#__PURE__*/(0, _jsx2.default)(_Row.default, {}, void 0, _h || (_h = /*#__PURE__*/(0, _jsx2.default)("h3", {}, void 0, "stepId values:")), /*#__PURE__*/(0, _jsx2.default)("ol", {}, void 0, getStepIds().map(function (sid) {
            return /*#__PURE__*/(0, _jsx2.default)("li", {}, "key_".concat(sid), !!sid && sid === currentStepId ? /*#__PURE__*/(0, _jsx2.default)("h3", {}, void 0, "".concat(sid, " <== CUR-STEP")) : [/*#__PURE__*/(0, _jsx2.default)(_WorkflowStepIdButton.default, {
              id: "btnId_".concat(sid),
              stepId: sid,
              bsStyle: "primary",
              bsSize: "xsmall",
              onValidateTransition: _this2.handleValidateTransition,
              autoShowLoading: true,
              nextStepIdOverride: _this2.state.useJumpBackBehavior ? currentStepId : null,
              previousStepIdOverride: _this2.state.useJumpBackBehavior ? currentStepId : null
            }, "0", sid), !!sid && sid === getNextStepId(currentStepId) ? '<== NEXT-STEP' : null, !!sid && sid === getPreviousStepId(currentStepId) ? '<== PREV-STEP' : null]);
          }))), /*#__PURE__*/(0, _jsx2.default)(_Row.default, {}, void 0, _h2 || (_h2 = /*#__PURE__*/(0, _jsx2.default)("h3", {}, void 0, "error steps:")), /*#__PURE__*/(0, _jsx2.default)("ol", {}, void 0, (0, _get2.default)(_this2.props, 'errorStepIds', []).map(function (sid) {
            return /*#__PURE__*/(0, _jsx2.default)("li", {}, "key_".concat(sid), !!sid && sid === currentStepId ? /*#__PURE__*/(0, _jsx2.default)("h3", {}, void 0, "".concat(sid, " <== CUR-STEP")) : /*#__PURE__*/(0, _jsx2.default)(_WorkflowStepIdButton.default, {
              id: "btnId_".concat(sid),
              stepId: sid,
              bsStyle: "primary",
              bsSize: "xsmall",
              onValidateTransition: _this2.handleValidateTransition,
              autoShowLoading: true
            }, void 0, sid));
          })))), /*#__PURE__*/(0, _jsx2.default)(_Col.default, {
            sm: 12,
            md: 6
          }, void 0, _h3 || (_h3 = /*#__PURE__*/(0, _jsx2.default)("h3", {}, void 0, "extendedStateByStepId")), /*#__PURE__*/(0, _jsx2.default)("pre", {}, void 0, "".concat(_circularJson.default.stringify(extendedStateByStepId, null, 2))), _hr || (_hr = /*#__PURE__*/(0, _jsx2.default)("hr", {})), _h4 || (_h4 = /*#__PURE__*/(0, _jsx2.default)("h3", {}, void 0, "getStatus():")), /*#__PURE__*/(0, _jsx2.default)("pre", {}, void 0, "".concat(_circularJson.default.stringify(getStatus(), null, 2))))));
        }

        return null;
      }), this.props.children));
    }
  }]);
  return WorkflowDebugInfo;
}(_react.default.Component);

WorkflowDebugInfo.displayName = 'WorkflowV2.DebugInfo';
var _default = WorkflowDebugInfo;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/workflow/impl/WorkflowDebugInfo.js
// module id = 4515
// module chunks = 25